import { Form } from '../entities/Form';

export function getBudgetFromDocument(document: Form, value: Record<string, any>): number | undefined {
  // console.log("🚀 ~ file: getBudgetFromDocument.ts ~ line 4 ~ getBudgetFromDocument ~ value", value)
  // console.log("🚀 ~ file: getBudgetFromDocument.ts ~ line 7 ~ getBudgetFromDocument ~ document.budgetField", document.budgetField)
  if (!document.budgetField) return undefined;

  return value[document.budgetField];
}
